import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import EditRoomImagesForm from "./Components/EditRoomImagesForm";
import fields from "../json/RoomImageField.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";
import { updateRoomImage, getRoomImageWithId, getRoomList } from "adminApi/RoomImagesApi/RoomImage";
import { RoomImagesRules } from "validation/ValidationRules";

const EditRoomImages = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, handleFileChange, setValues, setErrors } = useFormChange(
        initialValues,
        RoomImagesRules
    );

    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getRoomImageWithId, setValues);

    // Fetch room list in parent — not inside the form component
    const { data: roomList, loading: loadingRoomList } = useFetchAllData(getRoomList);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => {
                formData.append(key, val ?? "");
            });
            return await updateRoomImage({ id, data: formData });
        },
        (vals) => {
            // Copy before mutating to avoid modifying original state
            const v = { ...vals };
            if (typeof v.room_image === "string") delete v.room_image;
            delete v.room_imagePreview;
            const err = validateForm(v, RoomImagesRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Room Images updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch || loadingRoomList) && <Spinner isSpinner={true} />}
            <EditRoomImagesForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleFileChange={handleFileChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                imagePreview={values.room_imagePreview || values.room_image}
                loading={loadingSubmit}
                roomList={roomList || []}
                title="Update Room Image"
            />
        </>
    );
};

export default EditRoomImages;
